import { jsx, jsxs } from 'react/jsx-runtime';
import { SkeletonBox } from '../SkeletonBox/SkeletonBox.es.js';

const TermsOfServiceLoading = ()=>{
    return jsx("div", {
        className: "flex flex-col space-y-2",
        children: Array.from(Array(3).keys()).map((key)=>jsxs("div", {
                className: "flex flex-col space-y-1",
                children: [
                    jsx(SkeletonBox, {
                        className: "h-5 w-full",
                        loading: true
                    }),
                    jsx(SkeletonBox, {
                        className: "h-5 w-11/12",
                        loading: true
                    }),
                    jsx(SkeletonBox, {
                        className: "h-5 w-9/12",
                        loading: true
                    }),
                    jsx(SkeletonBox, {
                        className: "h-5 w-10/12",
                        loading: true
                    })
                ]
            }, key))
    });
};

export { TermsOfServiceLoading };
//# sourceMappingURL=TermsOfService.Loading.es.js.map
